export default "__VITE_ASSET__Bq$J4LJa__"